import { useContext, useEffect, useState } from 'react';
import {
	Image,
	LocaleCode,
	Merchant,
	MerchantToSet,
	validateMerchantToSet,
	validateImage,
	MERCHANT_LOGO_MIN_WIDTH,
	MERCHANT_LOGO_MIN_HEIGHT,
	MERCHANT_COVER_MIN_WIDTH,
	MERCHANT_COVER_MIN_HEIGHT,
} from '@anticatrade/shared';
import { MerchantResponse } from '@anticatrade/admin';
import { AppContext, appContext } from '../../../context/AppContext';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const useMerchant = () => {
	const [merchant, setMerchant] = useState<Merchant>();
	const [isLoading, setIsLoading] = useState<boolean>(true);

	const { api, handleError } = useContext(appContext as React.Context<AppContext>);
	const { i18n } = useTranslation();
	const location = useLocation();

	useEffect(() => {
		const fetchMerchant = async () => {
			let res: MerchantResponse;
			try {
				res = await api.merchant();
			} catch (err) {
				handleError(err as Error);
				setIsLoading(false);
				return;
			}
			setIsLoading(false);
			setMerchant(res.merchant);
		};

		fetchMerchant();
	}, [location.key]);

	const saveMerchant = async (
		merchantToSet: MerchantToSet,
		logo: Image | undefined,
		cover: Image | undefined,
	) => {
		const localeCode = i18n.language as LocaleCode;
		validateMerchantToSet(merchantToSet, localeCode);
		await validateImage(
			logo,
			localeCode,
			'logo',
			MERCHANT_LOGO_MIN_WIDTH,
			MERCHANT_LOGO_MIN_HEIGHT,
			true,
			false,
		);
		if (cover != null) {
			await validateImage(
				cover,
				localeCode,
				'cover',
				MERCHANT_COVER_MIN_WIDTH,
				MERCHANT_COVER_MIN_HEIGHT,
				false,
				false,
			);
		}

		// Determine if the cover was removed: it existed on the
		// merchant but the user has cleared it.
		const hadCover = merchant != null && merchant.cover != null && merchant.cover.fileName !== '';
		const removeCover = hadCover && cover == null;

		await api.updateMerchant(merchantToSet, logo, cover, removeCover);
	};

	return {
		isLoading,
		merchant,
		saveMerchant,
	};
};

export { useMerchant };
